import React from 'react';

import { AiAvatar } from '~/components/AiChat/components/Message/AiAvatar';
import { MessageLayout } from '~/components/AiChat/components/Message/MessageLayout';
import { MESSAGE_VARIANT } from '~/components/AiChat/components/Message/MessageTypes';
import { MessageLoader } from '~/components/AiChat/components/MessageLoader/MessageLoader';

const senderName = (assistantName: string) => `${assistantName} - AI Assistance`;

export const ChatLoadingMessage: React.FC<{ assistantName: string }> = ({ assistantName }) => {
  return (
    <MessageLayout avatar={<AiAvatar />} variant={MESSAGE_VARIANT.AI}>
      <div className="flex w-full flex-col pt-8">
        <span className="text-base font-bold">{senderName(assistantName)}</span>
      </div>
      <div className="flex w-full">
        <MessageLoader />
      </div>
    </MessageLayout>
  );
};
